import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import SeasonSelector from './SeasonSelector';
import { NAV_SECTIONS, isNavItemActive } from '../config/navigation';

const COLLAPSED_STORAGE_KEY = 'sidebarCollapsed';

const ModernSidebar = () => {
  const [isCollapsed, setIsCollapsed] = useState(
    () => localStorage.getItem(COLLAPSED_STORAGE_KEY) === 'true'
  );
  const location = useLocation();
  const navigate = useNavigate();
  const { user, logout } = useAuth();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  /* A class rather than an inline width, so the widths stay in the two CSS
     custom properties instead of being duplicated as literals here. */
  React.useEffect(() => {
    document.querySelector('.main-content')?.classList.toggle('sidebar-collapsed', isCollapsed);
  }, [isCollapsed]);

  const toggleSidebar = () => {
    setIsCollapsed((collapsed) => {
      localStorage.setItem(COLLAPSED_STORAGE_KEY, String(!collapsed));
      return !collapsed;
    });
  };

  const menuItems = NAV_SECTIONS;

  return (
    <div className={`modern-sidebar ${isCollapsed ? 'collapsed' : ''}`}>
      <div className="sidebar-header">
        <div className="logo-section">
          <div className="logo-icon">
            <i className="fas fa-tractor"></i>
          </div>
          {!isCollapsed && (
            <div className="logo-text">
              <h2>Farm</h2>
            </div>
          )}
        </div>
        <button className="collapse-btn" onClick={toggleSidebar}>
          <i className={`fas fa-chevron-${isCollapsed ? 'right' : 'left'}`}></i>
        </button>
      </div>

      {!isCollapsed && (
        <div className="season-section">
          <SeasonSelector />
        </div>
      )}

      <nav className="sidebar-nav">
        {menuItems.map((section) => (
          <div key={section.id} className="nav-section">
            {!isCollapsed && <div className="nav-section-label">{section.title}</div>}
            {section.items.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`nav-item ${isNavItemActive(item, location.pathname) ? 'active' : ''}`}
                title={isCollapsed ? item.label : ''}
              >
                <div className="icon-wrapper">
                  <i className={`fas ${item.icon}`}></i>
                </div>
                {!isCollapsed && <span className="label">{item.label}</span>}
              </Link>
            ))}
          </div>
        ))}
      </nav>

      <div style={{
        padding: isCollapsed ? '1rem 0.5rem' : '1rem 1.25rem',
        borderTop: '1px solid rgba(255,255,255,0.08)',
        marginTop: 'auto',
      }}>
        {!isCollapsed && user && (
          <div style={{
            fontSize: '0.75rem',
            color: '#718096',
            marginBottom: '0.5rem',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
          }}>
            <i className="fas fa-user-circle" style={{ marginRight: '0.4rem', color: '#4a7c59' }}></i>
            {user.username}
          </div>
        )}
        <button
          onClick={handleLogout}
          title="Wyloguj"
          style={{
            width: '100%',
            display: 'flex',
            alignItems: 'center',
            gap: isCollapsed ? '0' : '0.75rem',
            justifyContent: isCollapsed ? 'center' : 'flex-start',
            padding: isCollapsed ? '0.6rem' : '0.6rem 0.75rem',
            background: 'rgba(229, 62, 62, 0.1)',
            border: '1px solid rgba(229, 62, 62, 0.2)',
            borderRadius: '8px',
            color: '#fc8181',
            cursor: 'pointer',
            fontSize: '0.875rem',
            fontWeight: '500',
            transition: 'background 0.2s',
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.background = 'rgba(229, 62, 62, 0.2)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.background = 'rgba(229, 62, 62, 0.1)';
          }}
        >
          <i className="fas fa-sign-out-alt"></i>
          {!isCollapsed && <span>Wyloguj</span>}
        </button>
      </div>
    </div>
  );
};

export default ModernSidebar;
